module.exports = __webpack_public_path__ + "epdf-app/dashboard/batch/batch-details-1YpYpQHx.html";